"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConflictExpClassTitle = exports.ConflictContentWrapper = exports.ConflictDescriptionWrapper = exports.ConflictClass = exports.ConflictCardText = exports.ConflictCard = exports.Wrapper = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Wrapper = _styledComponents["default"].div.withConfig({
  displayName: "TrafficAppointmentConflicCardStyles2__Wrapper",
  componentId: "sc-1cwdnc6-0"
})(["display:flex;flex-direction:column;height:100%;width:100%;text-align:center;color:", ";position:relative;overflow:hidden;", ""], function (_ref) {
  var fontColor = _ref.fontColor;
  return fontColor;
}, function (_ref2) {
  var isOverAppointment = _ref2.isOverAppointment;
  return isOverAppointment && 'border: 0.2rem solid orange; box-sizing: border-box;';
});

exports.Wrapper = Wrapper;

var ConflictCard = _styledComponents["default"].div.withConfig({
  displayName: "TrafficAppointmentConflicCardStyles2__ConflictCard",
  componentId: "sc-1cwdnc6-1"
})(["flex:1;background:#fff;color:", ";text-align:left;margin-left:", ";margin-right:", ";font-size:10px;border-radius:0.2rem;border:", ";cursor:pointer;position:absolute;height:100%;width:", "%;border-left:8px ", " solid;", " padding-left:3px;box-sizing:border-box;border-radius:15px;"], function (_ref3) {
  var background = _ref3.background;
  return background === 'white' || background === 'transparent' ? '#6197F5' : background;
}, function (_ref4) {
  var begin = _ref4.begin;
  return begin;
}, function (_ref5) {
  var end = _ref5.end;
  return end;
}, function (_ref6) {
  var searched = _ref6.searched;
  return searched ? '4px solid #ffbf00' : "1px solid ".concat(function (_ref7) {
    var border = _ref7.border;
    return border;
  });
}, function (_ref8) {
  var beginNumber = _ref8.beginNumber,
      endNumber = _ref8.endNumber;
  return 100 - beginNumber - endNumber;
}, function (_ref9) {
  var background = _ref9.background;
  return background;
}, function (_ref10) {
  var background = _ref10.background;
  return background === 'white' || background === 'transparent' ? 'border: 0.05rem #6197F5 solid;' : '';
});

exports.ConflictCard = ConflictCard;

var ConflictCardText = _styledComponents["default"].div.withConfig({
  displayName: "TrafficAppointmentConflicCardStyles2__ConflictCardText",
  componentId: "sc-1cwdnc6-2"
})(["flex:auto;"]);

exports.ConflictCardText = ConflictCardText;

var ConflictClass = _styledComponents["default"].div.withConfig({
  displayName: "TrafficAppointmentConflicCardStyles2__ConflictClass",
  componentId: "sc-1cwdnc6-3"
})(["flex:auto;border:1px solid;border-radius:1rem;display:flex;align-items:center;justify-content:center;font-size:8px;height:0.8rem;"]);

exports.ConflictClass = ConflictClass;

var ConflictDescriptionWrapper = _styledComponents["default"].div.withConfig({
  displayName: "TrafficAppointmentConflicCardStyles2__ConflictDescriptionWrapper",
  componentId: "sc-1cwdnc6-4"
})(["display:flex;flex-direction:row;align-items:center;justify-content:flex-start;font-size:10px;background:#fff;color:", ";border-radius:.2rem .2rem 0 0;"], function (_ref11) {
  var background = _ref11.background;
  return background === 'white' || background === 'transparent' ? '#6197F5' : background;
});

exports.ConflictDescriptionWrapper = ConflictDescriptionWrapper;

var ConflictContentWrapper = _styledComponents["default"].div.withConfig({
  displayName: "TrafficAppointmentConflicCardStyles2__ConflictContentWrapper",
  componentId: "sc-1cwdnc6-5"
})(["display:flex;flex-direction:column;justify-content:flex-start;font-size:10px;"]);

exports.ConflictContentWrapper = ConflictContentWrapper;

var ConflictExpClassTitle = _styledComponents["default"].div.withConfig({
  displayName: "TrafficAppointmentConflicCardStyles2__ConflictExpClassTitle",
  componentId: "sc-1cwdnc6-6"
})(["display:flex;flex-direction:row;justify-content:center;align-items:center;height:.8rem;width:auto;min-width:.8rem;font-size:8px;border:1px solid;border-radius:1.6rem;padding:0px;"]);

exports.ConflictExpClassTitle = ConflictExpClassTitle;